(() => {
  if (window.__TP_HEADER_SEARCH_BRIDGE__) return;
  window.__TP_HEADER_SEARCH_BRIDGE__ = true;

  const TRIGGER_SELECTOR = '[data-tp-search-trigger], [data-search-mobile], [data-search-menu], [data-search-menu-sticky-form]';
  const POPUP_SELECTOR = '#halo-search-popup.tp-search-drawer';
  const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const LEGACY_BODY_CLASSES = [
    'sticky-search-menu-open',
    'search-open',
    'search_popup_open',
    'search-popup-open',
    'open-search',
    'open_search_desktop',
    'open_search_mobile'
  ];

  let opener = null;

  const getPopup = () => document.querySelector(POPUP_SELECTOR);
  const getTriggers = () => [...document.querySelectorAll(TRIGGER_SELECTOR)];

  const neutraliseUsfSearch = () => {
    try {
      window.usf?.utils?.hideInstantSearch?.();
    } catch (error) {}
  };

  const sanitiseMobileTriggers = () => {
    document.querySelectorAll('details-modal.header__search [data-search-mobile]').forEach((summary) => {
      const host = summary.closest('details-modal');
      if (!host) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = `${String(summary.className || '')
        .replace(/\bheader__icon--summary\b/g, '')
        .replace(/\bmodal__toggle\b/g, '')
        .replace(/\s+/g, ' ')
        .trim()} tp-search-trigger`;
      button.innerHTML = summary.innerHTML;
      button.setAttribute('aria-label', summary.getAttribute('aria-label') || 'Search');
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'halo-search-popup');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('data-search-mobile', '');
      button.setAttribute('data-tp-search-trigger', '');

      const hostStyle = host.getAttribute('style');
      if (hostStyle) button.setAttribute('style', hostStyle);
      button.style.appearance = 'none';
      button.style.webkitAppearance = 'none';
      button.style.border = '0';
      button.style.background = 'transparent';
      button.style.padding = '0';
      button.style.font = 'inherit';
      button.style.color = 'inherit';

      host.replaceWith(button);
    });

    document.querySelectorAll('[data-search-mobile]').forEach((trigger) => {
      trigger.setAttribute('data-tp-search-trigger', '');
    });
  };

  const preparePopup = () => {
    const popup = getPopup();
    if (!popup) return null;

    if (popup.dataset.tpSearchIsolated !== 'true') {
      popup.classList.remove('halo-popup', 'halo-search-popup');
      popup.removeAttribute('data-search-popup');
      popup.querySelector('.halo-popup-wrapper')?.classList.remove('halo-popup-wrapper');
      popup.querySelector('.halo-popup-content')?.classList.remove('halo-popup-content');
      popup.querySelectorAll('.header-search-close').forEach((button) => button.classList.remove('header-search-close'));
      popup.dataset.tpSearchIsolated = 'true';
    }

    return popup;
  };

  const closeLegacySearch = () => {
    document.querySelectorAll('.header__search details[open], details.search_details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
    document.body.classList.remove(...LEGACY_BODY_CLASSES);
    neutraliseUsfSearch();
  };

  const syncTriggers = (activeTrigger = null) => {
    getTriggers().forEach((trigger) => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'halo-search-popup');
      trigger.setAttribute('aria-expanded', trigger === activeTrigger ? 'true' : 'false');
    });
  };

  const focusPrimaryInput = (popup) => {
    const input = popup?.querySelector('#TP-Search-In-Header, [data-tp-search-input]');
    if (!input) return null;

    input.removeAttribute('readonly');
    input.removeAttribute('disabled');

    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }

    const length = input.value.length;
    if (typeof input.setSelectionRange === 'function') {
      try {
        input.setSelectionRange(length, length);
      } catch (error) {}
    }

    return input;
  };

  const openSearch = (trigger) => {
    sanitiseMobileTriggers();
    const popup = preparePopup();
    if (!popup) return false;

    opener = trigger || document.activeElement;
    closeLegacySearch();
    syncTriggers(trigger || null);

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tp-search-open');

    // Mobile Safari only reliably opens the keyboard when focus happens
    // synchronously inside the original tap/click gesture.
    focusPrimaryInput(popup);

    requestAnimationFrame(() => {
      if (popup.classList.contains('is-open') && !popup.contains(document.activeElement)) {
        focusPrimaryInput(popup);
      }
    });

    return true;
  };

  const closeSearch = (restoreFocus = true) => {
    const popup = getPopup();
    if (!popup) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tp-search-open');
    closeLegacySearch();
    syncTriggers(null);

    const focusTarget = opener;
    opener = null;

    if (restoreFocus && focusTarget && document.contains(focusTarget)) {
      requestAnimationFrame(() => {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch (error) {
          focusTarget.focus();
        }
      });
    }
  };

  const visibleFocusables = (popup) => [...popup.querySelectorAll(FOCUSABLE_SELECTOR)].filter((element) => {
    const style = getComputedStyle(element);
    return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none';
  });

  const initialise = () => {
    sanitiseMobileTriggers();
    const popup = preparePopup();
    if (!popup) return;

    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-hidden', popup.classList.contains('is-open') ? 'false' : 'true');
    popup.setAttribute(
      'aria-label',
      (document.documentElement.lang || '').toLowerCase().startsWith('ar') ? 'البحث في توني بونس' : 'Search Toni Pons'
    );
    syncTriggers(popup.classList.contains('is-open') ? opener : null);
  };

  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const trigger = target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      if (!getPopup()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openSearch(trigger);
      return;
    }

    const popup = getPopup();
    if (!popup || !popup.classList.contains('is-open')) return;

    const closeButton = target.closest('[data-search-close-popup]');
    if (closeButton && popup.contains(closeButton)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSearch(true);
      return;
    }

    if (target === popup) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSearch(true);
    }
  }, true);

  // USF tries to refocus its own instant-search input around 300ms after
  // mobile search opens. While the TP drawer is open, keep focus inside it.
  document.addEventListener('focusin', (event) => {
    const popup = getPopup();
    if (!popup || !popup.classList.contains('is-open')) return;
    if (popup.contains(event.target)) return;

    event.stopImmediatePropagation();
    focusPrimaryInput(popup);
  }, true);

  window.addEventListener('keydown', (event) => {
    const popup = getPopup();
    if (!popup || !popup.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      closeSearch(true);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusables = visibleFocusables(popup);
    if (!focusables.length) {
      event.preventDefault();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  sanitiseMobileTriggers();
  preparePopup();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
  window.TPHeaderSearch = { open: openSearch, close: closeSearch };
})();
